export default "assets/images/logo-25bfdad5.svg";